import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")

// Reveal the back-to-top button (src/_partials/_back_to_top.erb) once the
// visitor has scrolled roughly a screen down.
document.addEventListener("DOMContentLoaded", () => {
  const button = document.querySelector("[data-back-to-top]")
  if (!button) return

  const hiddenClasses = ["invisible", "opacity-0", "translate-y-2"]
  const update = () => {
    const show = window.scrollY > window.innerHeight * 0.75
    hiddenClasses.forEach((c) => button.classList.toggle(c, !show))
  }

  window.addEventListener("scroll", update, { passive: true })
  update()
})
